import { render, staticRenderFns } from "./ThgQuickCheckout.vue?vue&type=template&id=1c7fdfb3&scoped=true"
import script from "./ThgQuickCheckout.vue?vue&type=script&lang=ts"
export * from "./ThgQuickCheckout.vue?vue&type=script&lang=ts"
import style0 from "./ThgQuickCheckout.vue?vue&type=style&index=0&id=1c7fdfb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7fdfb3",
  null
  
)

export default component.exports